<template lang="pug">
	section(:class="{'force-mobile': forceMobile}")
		p
			| Knowing this helps us better customize your experience and offer better recommendations
		.error-message(v-show="error") {{errorMessage}}
		div
			.child-container
				.py-3
					span.text I am saving for
					.label-and-input-wrapper.mobile
						sfc-select-wrapper.select-wrapper.child-age.d-inline-block(:errorMessage="'Invalid selection'" :error="errorChildrenCount" :flat="false")
							select(v-model="childrenCount" @change="validateNext()")
								option(:value="null" disabled="disabled") Select one
								option(value="1") 1 child
								option(value="2") 2 children
								option(value="3") 3 children
								option(value="4") more than 3 children
				.py-3
					span.text The youngest child I'm saving for is
					.label-and-input-wrapper.mobile
						sfc-select-wrapper.select-wrapper.child-age.d-inline-block(:errorMessage="'Invalid selection'" :error="errorYoungerAge" :flat="false")
							select(v-model="youngerAge" @change="validateNext()")
								option(:value="null" disabled="disabled") Select one
								option(value="-1") not born yet
								option(value="0") newborn
								option(value="1") 1 year old
								option(value="2") 2 years old
								option(value="3") 3 years old
								option(value="4") 4 years old
								option(value="5") 5 years old
								option(value="6") 6 years old
								option(value="7") 7 years old
								option(value="8") 8 years old
								option(value="9") 9 years old
								option(value="10") 10 years old
								option(value="11") 11 years old
								option(value="12") 12 years old
								option(value="13") 13 years old
								option(value="14") 14 years old
								option(value="15") 15 years old
								option(value="16") 16 years old
								option(value="17") 17 years old
								option(value="18") 18+ years old
				.py-3(v-if="showOld")
					span.d-none.d-sm-inline-block.text The oldest child I'm saving for is
					.label-and-input-wrapper.mobile
						sfc-select-wrapper.select-wrapper.child-age.d-inline-block(:errorMessage="'Invalid selection'" :error="errorOlderAge" :flat="false")
							select(v-model="olderAge" @change="validateNext()")
								option(:value="null" disabled="disabled") Select one
								option(value="-1") not born yet
								option(value="0") newborn
								option(value="1") 1 year old
								option(value="2") 2 years old
								option(value="3") 3 years old
								option(value="4") 4 years old
								option(value="5") 5 years old
								option(value="6") 6 years old
								option(value="7") 7 years old
								option(value="8") 8 years old
								option(value="9") 9 years old
								option(value="10") 10 years old
								option(value="11") 11 years old
								option(value="12") 12 years old
								option(value="13") 13 years old
								option(value="14") 14 years old
								option(value="15") 15 years old
								option(value="16") 16 years old
								option(value="17") 17 years old
								option(value="18") 18+ years old

		.continue-button
			sfc-button.mr-4(:blue="false" :back-arrow="true" @click="back()")
			sfc-button(text="NEXT" :blue="true" :continue-arrow="true" @click="next()")

</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'
.text-input
	>>> input
		@media(max-width: 575px)
			font-size: body-font-size-md !important
.text
	margin-right: 10px

.icon
	cursor: pointer
	margin-left: 10px

.child-container
	margin-top: 15px
	&:first-child
		margin-top: 30px

.child-age
	width 100%
	@media (min-width: 421px)
		max-width 150px
	@media (min-width: 991px)
		max-width 150px
	@media (max-width: 575px)
		max-width 185px

	>>> select
		@media(max-width: 575px)
			line-height: body-font-line-height
			font-size: body-font-size-md

.child-name
	>>> .tb
		width 100%
		@media (min-width: 500px)
			max-width 150px
		@media (min-width: 991px)
			max-width 150px
		@media (max-width: 575px)
			max-width 130px
	>>> input
		@media (max-width: 575px)
			line-height: body-font-line-height
			font-size: body-font-size-md

.select-wrapper
	margin: 0 !important
	&.error
		>>> .select-container
			border: 1px solid sfc-brick

.label-and-input-wrapper
	display: inline-block
	label
		margin: 0
		font-size: body-font-size-sm !important

.remove-child
	@media (max-width: 575px)
		margin-left: 20px !important
.add-child
	cursor pointer
.close-in-word
	cursor pointer
	font-size: body-font-size
	top: -25px
	right: 0px
	position: absolute
	color: #fff

.add-a-child-link
	margin-top: 10px

.error-message
	margin-bottom: 20px
	background-color: sfc-brick
	border: 1px solid #d0021b
	border-radius()
	padding: 5px 15px
	color: #fff

.continue-button
	margin-top: 60px

section.force-mobile
	@media(min-width: 576px)
		.child-age
			max-width 150px

		.child-name
			>>> .tb
				max-width 150px

		.remove-child
			margin-left: 20px !important

		.child-container
			span.text
				display: none !important
			.child-name-label
			.child-age-label
				display: block !important

		.select-wrapper
			>>> .select-container
				width: 150px



</style>

<script>
import SfcInputV2 from '@/common/components/inputs/v2/textbox'
import SfcSelectV2 from '@/common/components/inputs/v2/select'
import SfcButton from '@/common/components/sfc-button'
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {

	components:{
		SfcInputV2,
		SfcSelectV2,
		SfcButton
	},

	props: {
		forceMobile: {
			default: false
		}
	},
	computed:{
		showOld(){
			return this.childrenCount != "null" && this.childrenCount != null && this.childrenCount != "1"
		},
		error(){
			return this.errorChildrenCount || this.errorYoungerAge || this.errorOlderAge
		}
	},
	data() {
		return {
			errorChildrenCount: false,
			errorYoungerAge: false,
			errorOlderAge: false,
			validateOnChange: false,
			childrenCount: null,
			youngerAge: null,
			olderAge: null,
			errorMessage: `Sorry, child information is required.`,
			progressLength: 25
		}
	},

	methods: {

		back(){
			this.$emit('next', -1*this.progressLength, "Who are you saving for?", "sfc-who-are-you-saving-for")
		},
		validateNext(){
			this.errorChildrenCount = false
			this.errorYoungerAge = false
			this.errorOlderAge = false
			if (this.validateOnChange){
				this.errorChildrenCount = (this.childrenCount == null || this.childrenCount == "null")
				this.errorYoungerAge = (this.youngerAge == null || this.youngerAge == "null")
				if (this.showOld){
					this.errorOlderAge = (this.olderAge == null || this.olderAge == "null")
				}
			}
			return !this.error
		},
		next(){
			this.validateOnChange = true

			if(this.validateNext()){

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "youngerAge", value: this.youngerAge})
				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "olderAge", value: this.olderAge})
				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "childrenCount", value: this.childrenCount})

				SfcTrackingService.trackAnalyticsAction("Savings Center Onboarding", "Child Age - next", "Submit", 0)

				this.$emit('next', this.progressLength, "How can we help you today?", "sfc-how-can-we-help-you-today")
			}
		},
	}
}
</script>
